module.exports = __webpack_public_path__ + "media/PWC-Safety-101.3c92db48.mp4";